import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, Paper, List, Modal, CircularProgress, ListItem, ListItemText, Divider } from '@material-ui/core';

import { pt } from 'date-fns/esm/locale';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

import useStyles from './styles';

function ModalScheduler(props) {
  const {
    modal,
    onClose,
    isLoading,
    scheduleDates,
    setScheduleDate
  } = props;

  const classes = useStyles();
  const rootRef = React.useRef(null);
  const [ timeSlots, setTimeSlots ] = useState([]);
  const [ selected, setSelected ] = React.useState(new Date());
  const [ date, setDate ] = useState('');

  useEffect(() => {
    handleDateChange(new Date());
    // if(scheduleDates.length > 0) {
      
    // }
  }, [scheduleDates]);

  useEffect(() => {
    if(timeSlots.length > 0) {
      setTimeSlots(timeSlots);
    }
  }, [timeSlots]);

  const handleDateChange = (date) => { 
    setSelected(date); 
    setDate(format(date, 'dd/MM/yyyy')); 
    const hasDate = scheduleDates.filter((item) => {
      if(item.date === format(date, 'yyyy-MM-dd')) {
        return item.schedules;
      }
    });
    setTimeSlots(hasDate[0] ? hasDate[0].schedules : []);
  };

  const handleToggle = (item) => {
    setSelected(item);
    setScheduleDate(format(item.startTime, 'dd/MM/yyyy HH:mm'));
    onClose();
  };

  return (
    <Modal
      open={modal}
      onClose={onClose}
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
      className={classes.modal}
      container={() => rootRef.current}
    >
      <div className={classes.root}> 
        <Paper classes={{root: classes.paper}}>
          <div onClick={onClose} className={classes.closeButton}>
              <CloseIcon />
          </div>
          {isLoading ? 
              <div className={classes.loadingPosition}>
                  <CircularProgress 
                      size={80}
                      className={classes.buttonProgress}
                  />
              </div> 
          : 
            <Grid container>
              <Grid item xs={6}>
                <DayPicker 
                  mode="single"
                  selected={selected}
                  onSelect={handleDateChange}
                  locale={pt}
                />
              </Grid>
              <Grid item xs={1} >
                <Divider orientation="vertical" />
              </Grid >
              <Grid item xs={5} >  
                <div style={{marginLeft: '-15px'}}>
                  <h3>Dia: {date}</h3>
                  <p><b>Selecione um Horário:</b></p>
                </div>
                <Paper className={classes.paperList}>
                  <List className={classes.listSize}>
                    { timeSlots.length > 0 ?
                      timeSlots.map((item, index) => (                      
                        <ListItem 
                          className={selected === item ? classes.listItemSelected : classes.listItem}
                          key={index} 
                          role={undefined} 
                          dense 
                          button 
                          onClick={() => handleToggle(item)}
                          selected={selected === item}
                        >
                        <ListItemText 
                          className={classes.listText} 
                          primary={`${format(item.startTime, 'HH:mm')} - ${format(item.endTime, 'HH:mm')}`} 
                        />
                      </ListItem>
                      )) : <p>Não há horários disponíveis para esta data!</p>
                    }
                  </List>
                </Paper>
              </Grid>
            </Grid>
          }
        </Paper>
      </div>
    </Modal>
  );
}

ModalScheduler.propTypes={
    message: PropTypes.string,
    name: PropTypes.string,
    modal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    id: PropTypes.any  
};
export default ModalScheduler;